import AsyncDataTable from "@/components/core/async-data-table/async-data-table";
import {
  DatableColumnType,
  FilterType,
  propertyType,
} from "@/components/core/async-data-table/type";
import { endpoints } from "@/api/endpoints/endpoints";
import FilterHeader from "@/components/core/async-data-table/filter-header";
import ActionPopover from "@/components/action/action-popover";
import { Plus } from "lucide-react";
import { useLocation } from "wouter";
import { useDeletePickup } from "@/services/pickup-service";
import { useToast } from "@/hooks/use-toast";
import { useState } from "react";

const PickupAsyncTable = () => {
  const [, setLocation] = useLocation();
  const deletePickup = useDeletePickup();
  const [refreshPage, setRefreshPage] = useState(false);
  const { toast } = useToast();

  const handleDelete = async (pickupId: string) => {
    try {
      await deletePickup.execute(pickupId);
      toast({
        title: "Success",
        description: "Pickup deleted successfully",
      });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to delete pickup",
        variant: "destructive",
      });
    }

    setRefreshPage(!refreshPage);
  };

  const cols: DatableColumnType[] = [
    {
      name: "orderId",
      id: "orderId",
      label: "Order ID",
      searchable: true,
      orderable: true,
      datatype: "string",
    },
    {
      name: "courierName",
      id: "courierName",
      label: "Courier Name",
      searchable: true,
      orderable: true,
      datatype: "string",
    },
    {
      name: "pickupStatus",
      id: "pickupStatus",
      label: "Pickup Status",
      searchable: true,
      orderable: true,
      datatype: "string",
    },
    {
      name: "pickupTime",
      id: "pickupTime",
      label: "Pickup Time",
      searchable: true,
      orderable: true,
      datatype: "custom",
      Render: ({ row }: { row: any }) => {
        if (!row.pickupTime)
          return <span className="text-sm text-gray-400">-</span>;
        const date = new Date(row.pickupTime);
        return (
          <span className="text-sm text-gray-700 font-medium">
            {date.toLocaleString()}
          </span>
        );
      },
    },
    {
      name: "action",
      id: "action",
      label: "Action",
      Render: ({ row }: { row: any }) => (
        <ActionPopover
          onEdit={() => {
            setLocation(`/pickups/${row.id}/edit`);
          }}
          onDelete={() => {
            handleDelete(row.id);
          }}
        />
      ),
    },
  ];

  const defaultFilterProp: propertyType[] = [
    { propName: "orderId", value: "", type: FilterType.STRING },
    { propName: "courierName", value: "", type: FilterType.STRING },
    { propName: "pickupStatus", value: "", type: FilterType.STRING },
  ];

  return (
    <AsyncDataTable
      dataUrl={endpoints.pickup.list}
      columns={cols}
      autoIndex
      FilterComponent={FilterHeader}
      refreshPage={refreshPage}
      defaultFilterProp={defaultFilterProp}
      showPageHeader={false}
      pageTitle="Pickups"
      pageSubtitle="Manage your pickups"
      headerAction={() => {}}
      headerActionText="Create Pickup"
      headerActionIcon={<Plus size={18} />}
    />
  );
};

export default PickupAsyncTable;
